import PropTypes from 'prop-types';

import {Divider, Space} from 'antd';

import useAntDesignBreakPoints from '../../../hooks/useAntDesignBreakPoints/useAntDesignBreakPoints';
import ClientOrganizationLogo from './ClientOrganizationLogo';
import Crisis24Logo from './Crisis24Logo';
import SingleLogo from './SingleLogo';

import './HeaderLogo.css';

function HeaderLogo(props) {
  const {clientLogoUrl} = props;

  const {isExtraSmall, isSmall} = useAntDesignBreakPoints();

  const isLessThan768px = isExtraSmall || isSmall;

  return (
    <Space size={10} split={<Divider className={'logo-divider'} type="vertical" />} className="HeaderLogo">
      {isLessThan768px ? (
        <SingleLogo clientLogoUrl={clientLogoUrl} />
      ) : (
        <>
          <Crisis24Logo />
          {clientLogoUrl && <ClientOrganizationLogo clientLogoUrl={clientLogoUrl} />}
        </>
      )}
    </Space>
  );
}

HeaderLogo.propTypes = {
  clientLogoUrl: PropTypes.string,
};

export default HeaderLogo;
